module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Avietchii/Kanagawa_Avietchii_GFDL_RCP26_Mid.png";